import { useSearchParams, Link } from "react-router-dom";
import { useFetch } from "../lib/useData";
import { PageHero, Section } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1665003725647-3ae0f01140b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const { data: results } = useFetch(`/public/search?q=${encodeURIComponent(q)}`, [q]);
  const grouped = {};
  (results || []).forEach((r) => { (grouped[r.type] = grouped[r.type] || []).push(r); });

  return (
    <div>
      <PageHero title="Search Results" subtitle={`Showing results for “${q}”`} image={HERO} />
      <Section className="max-w-3xl">
        {(results || []).length === 0 ? (
          <p className="text-stone-500">No results found. Try another search term.</p>
        ) : (
          <div className="space-y-8" data-testid="search-results">
            {Object.entries(grouped).map(([type, items]) => (
              <div key={type}>
                <h3 className="font-display text-xl font-bold text-orange-700 mb-3">{type}</h3>
                <div className="space-y-2">
                  {items.map((r, i) => (
                    <Link key={i} to={r.path} className="block bg-white border border-amber-200 rounded-xl px-5 py-3 hover:shadow-md hover:border-orange-300 transition-all" data-testid={`search-result-${i}`}>
                      <span className="text-xs text-amber-700 font-semibold uppercase">{r.type}</span>
                      <div className="font-semibold text-stone-900">{r.title}</div>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
